import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from 'axios'
import { host } from '../../configuraciones'


//AQUI SE ADMINISTRAN LAS TABLAS 
//UNIDAD ALMACEN UBICACIÓN
//UNIDAD ENVASADO UBICACIÓN
//UNIDAD PRODUCCIÓN UBICACIÓN



const dataInicial = {

    unidadesAlmacen: [
      
    ],
    
    unidadesEnvasado: [
      
    ],
    
    unidadesProduccion: [
      
    ],
    ubicaciones:[

    ]
}


//DEFINICIÓN DE MÉTODOS *********************************************************************************************
const GET_UNIDADES_ALMACEN = 'GET_UNIDADES_ALMACEN'
const GET_UNIDADES_ENVASADO = 'GET_UNIDADES_ENVASADO'
const GET_UNIDADES_PRODUCCION = 'GET_UNIDADES_PRODUCCION'

//
const GET_UBICACION_BY_LOCALIDAD_AND_SUBLOCALIDAD = 'GET_UBICACION_BY_LOCALIDAD_AND_SUBLOCALIDAD'
const GET_UBICACION_BY_SUBLOCALIDAD = 'GET_UBICACION_BY_SUBLOCALIDAD'
//


const GET_ASOCIADO_BY_ID = 'GET_ASOCIADO_BY_ID'
const GET_ASOCIADO_BY_NOMBRE= 'GET_ASOCIADO_BY_NOMBRE'
const INSERT_ASOCIADO = 'INSERT_ASOCIADO'
const UPDATE_ASOCIADO = 'UPDATE_ASOCIADO'
//*******************************************************************************************************************



//MÉTODOS 
export const getUnidadesAlmacen = createAsyncThunk(
    GET_UNIDADES_ALMACEN,
    async () => {
        try {
            const fullUrl1 = host + `UnidadAlmacenUbicacion/obtenerUnidadesAlmacenUbicacion`
            const res1 = await axios.get(fullUrl1)
      
            //console.log(JSON.stringify(res1))                
            return res1.data

        } catch (error) {
            console.log(error);
        }
    }
)


//   - metodo para obtener las ubicaciones de acuerdo a 2 identificadores
        export const getUbicacionByLocalidadAndSublocalidad = createAsyncThunk(
            GET_UBICACION_BY_LOCALIDAD_AND_SUBLOCALIDAD,
            async (object) => {
                try {

                    console.log('(Localidad:'+object.idlocalidad+') y (Sublocalidad:'+object.idsublocalidad+')')
                    const fullUrl1 = host + `UbicacionInstalacion/obtenerUbicacionInstalacionByLocalidad/${object.idlocalidad}&${object.idsublocalidad}`
                    const res1 = await axios.get(fullUrl1)
            
                    //console.log(JSON.stringify(res1))                
                    return res1.data

                } catch (error) {
                    console.log(error);
                }
            }
        )

        export const getUbicacionBySublocalidad = createAsyncThunk(
            GET_UBICACION_BY_SUBLOCALIDAD,
            async (idsublocalidad) => {
                try {

                    console.log('(Sublocalidad:'+idsublocalidad+')')
                    const fullUrl1 = host + `UbicacionInstalacion/obtenerUbicacionInstalacionBySubLocalidad/${idsublocalidad}`
                    const res1 = await axios.get(fullUrl1)
            
                    //console.log(JSON.stringify(res1))                
                    return res1.data

                } catch (error) {
                    console.log(error);
                }
            }
        )

//
export const getUnidadesEnvasado = createAsyncThunk(
    GET_UNIDADES_ENVASADO,
    async () => {
        try {
           
            const fullUrl2 = host + `UnidadEnvasadoUbicacion/obtenerUnidadesEnvasadoUbicacion`
            const res2 = await axios.get(fullUrl2)

            
            //console.log(JSON.stringify(res1))                
            return res2.data

        } catch (error) {
            console.log(error);
        }
    }
)

export const getUnidadesProduccion = createAsyncThunk(
    GET_UNIDADES_PRODUCCION,
    async () => {
        try {
            

          
            const fullUrl3 = host + `UnidadProduccionUbicacion/obtenerUnidadesProduccionUbicacion`
            const res3 = await axios.get(fullUrl3)        
            //console.log(JSON.stringify(res1))                
            return res3.data

        } catch (error) {
            console.log(error);
        }
    }
)

export const getAsociadoById = createAsyncThunk(
    GET_ASOCIADO_BY_ID,
    async (idAsociado) => {
        try {
            const fullUrl = host + `DatosAsociado/getAsociadoById/${idAsociado}`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const getAsociadoByNombre = createAsyncThunk(
    GET_ASOCIADO_BY_NOMBRE,
    async (nombre) => {
        try {
            const fullUrl = host + `DatosAsociado/getAsociadoByNombre/${nombre}`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const insertAsociado = createAsyncThunk(
    INSERT_ASOCIADO,
    async (data) => {
        try {
            const fullUrl = host + `DatosAsociado/insertAsociado`
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)


export const updateInspector = createAsyncThunk(
    UPDATE_ASOCIADO,
    async (data) => {
        try {
            const fullUrl = host + `DatosAsociado/updateAsociado`
            const result = await axios.put(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const validarInstalacion = createAsyncThunk(
)

//****************************************************************************************************************



//EXPORTS DE MÉTODOS
export const metodosUnidadesSlice = createSlice({
    name: 'metodosUnidadesSlice',
    initialState: dataInicial,
    reducers: {
       
    },
    extraReducers: {
      
        [getUnidadesAlmacen.fulfilled]: (state, { payload }) => {
            state.unidadesAlmacen = payload.data
        },

        [getUnidadesEnvasado.fulfilled]: (state, { payload }) => {
            state.unidadesEnvasado = payload.data
        },

        [getUnidadesProduccion.fulfilled]: (state, { payload }) => {
            state.unidadesProduccion = payload.data
        },

        [getUbicacionByLocalidadAndSublocalidad.fulfilled]: (state, { payload }) => {
            state.ubicaciones = payload.data

        },
        [getUbicacionBySublocalidad.fulfilled]: (state, { payload }) => {
            state.ubicaciones = payload.data

        },
        
        [getAsociadoById.fulfilled]: (state, { payload }) => {
         
        },

        [getAsociadoByNombre.fulfilled]: (state, { payload }) => {
       
        },

        [insertAsociado.fulfilled]: (state, { payload }) => {
            state.data = payload.data
        },

        [updateInspector.fulfilled]: (state, { payload }) => {
            state.data = payload.data
        },

        [validarInstalacion.fulfilled]: (state, { payload }) => {
           
        },


    },
})

 export const { } = metodosUnidadesSlice.actions

export const UnidadesReducer = metodosUnidadesSlice.reducer
